import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CadExportFeaturesDTO } from '../cad-export-features.dto';

@Injectable({ providedIn: 'root' })
export class ProjectCadService {
  private readonly cadFeaturesUrl: string = 'project-cad/features';

  constructor(private wagoApiClient: WagoApiClient) { }

  public getCadExportFeatures(): Observable<CadExportFeaturesDTO> {
    return this.wagoApiClient.get<CadExportFeaturesDTO>(this.cadFeaturesUrl, null,
      { askToElevateUserFromGuestByLoggingIn: true, isErrorHandlingRequired: false });
  }
}
